import React from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Result, Typography } from "antd";
const { Paragraph, Text } = Typography;
const App = () => (
  <Result
    status="error"
    title="Servicio Suspendido"
    subTitle="Su servicio ha sido suspendido por una violación de términos y condiciones."
    extra={[
      <Button type="primary" key="console" href="/">
        ir a inicio
      </Button>,
    ]}
  >
    <div className="desc">
      <Paragraph>
        <Text
          strong
          style={{
            fontSize: 16,
          }}
        >
          Si crees que esto es un error, por favor contacta a soporte técnico.
        </Text>
      </Paragraph>
      <Paragraph>
        <CloseCircleOutlined className="site-result-demo-error-icon" /> Tu
        servicio ha sido suspendido por incumplimiento de terminos y condiciones.
      </Paragraph>
      <Paragraph>
        <CloseCircleOutlined className="site-result-demo-error-icon" /> Contacte
        a soporte técnico para más información.
      </Paragraph>
    </div>
  </Result>
);
export default App;
